import Cookies from 'js-cookie';
import { domain } from './domain';

export default () => Cookies.remove('token', { path: '/', domain: domain() });
